import React, { useEffect } from "react";
import styled from "styled-components";
import { FormRow, FormRowMessage, FormTextbox, FormDatePicker, FormDatePickerDropdowns, Alert, TitleStack, BlockButton } from "fiver-react-ui-components";
import NewDatePicker from "./datePicker";
import AddressLookup from "./addressField";
const StyledWrapper = styled.div``;

const SignupStep = ({
  translations,
  dateInputFormat,
  onStepClicked,
  isStepValid,
  values,
  errors,
  dirty,
  hasTextboxDatePicker,
  hasDropdownDatePicker,
  handleChange,
  handleBlur,
  setFieldError,
  setFieldTouched,
  setFieldValue,
  setTouched,
  colorPrimary,
  touched,
  showFallbackDatePicker,
  isNonUk
}) => {
  useEffect(() => {
    window.xtremepush("tag", "registration_personal_details", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []); // console.log("dateInputFormat", dateInputFormat);

  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(TitleStack, {
    title: `${translations.step} 1`,
    subtitle: translations.messagePersonalDetails,
    id: "step-title"
  }), !isNonUk && /*#__PURE__*/React.createElement(Alert, {
    isDefault: true,
    margin: "0 0 1rem",
    textAlign: "left",
    id: "firstname-alert"
  }, translations.firstNameMessage), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    name: "firstName",
    placeholder: translations.firstName,
    value: values.firstName,
    isRequired: true,
    isError: values.firstName !== "" && errors.firstName,
    onChange: handleChange,
    onBlur: handleBlur,
    id: "firstname-field"
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: values.firstName !== "" && errors.firstName,
    id: "fistname-error"
  }, errors.firstName), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    name: "lastName",
    placeholder: translations.lastName,
    value: values.lastName,
    isRequired: true,
    isError: values.lastName !== "" && errors.lastName,
    onChange: handleChange,
    onBlur: handleBlur,
    id: "lastname-field"
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: values.lastName !== "" && errors.lastName,
    id: "lastname-error"
  }, errors.lastName), /*#__PURE__*/React.createElement(FormRow, null, hasTextboxDatePicker ? /*#__PURE__*/React.createElement(FormDatePicker, {
    format: dateInputFormat,
    isRequired: true,
    isError: values.birthDate !== "" && errors.birthDate,
    value: values.birthDate,
    name: "birthDate",
    label: translations.birthDate,
    isFallback: showFallbackDatePicker,
    onChange: handleChange,
    onBlur: handleBlur,
    id: "birthdate-field"
  }) : hasDropdownDatePicker ? /*#__PURE__*/React.createElement(FormDatePickerDropdowns, {
    isError: values.birthDate !== "" && errors.birthDate,
    value: values.birthDate,
    name: "birthDate",
    label: translations.birthDate,
    onChange: handleChange,
    onBlur: handleBlur,
    id: "birthdate-field"
  }) : /*#__PURE__*/React.createElement(NewDatePicker, {
    dateInputFormat: dateInputFormat,
    values: values,
    errors: errors,
    handleBlur: handleBlur,
    handleChange: handleChange,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    translations: translations,
    id: "birthdate-field"
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    id: "birthdate-alert",
    margin: "0 0 1rem",
    isVisible: values.birthDate !== "" && errors.birthDate
  }, errors.birthDate), isNonUk ? /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    name: "postcode",
    placeholder: translations.zipCode,
    value: values.postcode,
    isRequired: true,
    isError: values.postcode !== "" && errors.postcode,
    onChange: handleChange,
    onBlur: handleBlur,
    id: "postcode-field"
  })) : /*#__PURE__*/React.createElement(AddressLookup, {
    translations: translations,
    values: values,
    errors: errors,
    handleChange: handleChange,
    handleBlur: handleBlur,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    colorPrimary: colorPrimary,
    touched: touched,
    id: "postcode-field"
  }), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: touched.postcode && errors.postcode,
    id: "postcode-alert"
  }, errors.postcode), /*#__PURE__*/React.createElement(Alert, {
    isDefault: true,
    margin: "0 0 1rem",
    textAlign: "left",
    id: "detailscorrect-alert"
  }, translations.detailsCorrectWarning), /*#__PURE__*/React.createElement(BlockButton, {
    onClick: () => onStepClicked(1),
    disabled: !isStepValid || !dirty,
    style: {
      marginBottom: "1rem"
    },
    id: "next-btn"
  }, translations.next), /*#__PURE__*/React.createElement(BlockButton, {
    to: "/",
    id: "back-btn"
  }, translations.back));
};

export default SignupStep;